
import { NgModule } from '@angular/core';
import { ApiResourceModule } from 'libraries/service/apiResource/apiResource.module';

import { OsmanCompanyResource } from './osman-company.resource';

@NgModule({
    imports: [
        ApiResourceModule,
    ],
    providers: [
        OsmanCompanyResource,
    ],
})
export class OsmanCompanyResourceModule {}